import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Icon from "../Common/Icon";
import actions from "../../actions/dienstregeling";
import Prices from "./Prices";

export class Detail extends Component {
  static propTypes = {
    config: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      showMap: false,
    };
  }

  handleSwitchDirection = () => {
    const directionId = this.props.dienstregeling.directionId;
    this.props.setDirection(directionId ? 0 : 1);
    this.setState({
      showMap: false,
    });
  };

  handleToggleMap = () => {
    const showMap = !this.state.showMap;
    this.setState({
      showMap,
    });
  };

  getGoogleMapsSrc() {
    const { routeId, directionId } = this.props.dienstregeling;
    const params = [
      { name: "directionId", value: directionId },
      { name: "routeId", value: routeId },
    ];

    const querystring = params
      .map(({ name, value }) => `${name}=${value}`)
      .join("&");
    return `/api/travelplanner/timetable/map?${querystring}`;
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.loading) return null;

    //Reset the show map button after each new submit
    return {
      ...state,
      showMap: false,
    };
  }

  render() {
    const {
      dienstregeling,
      config,
      loading, //, shapes
    } = this.props;
    if (!dienstregeling) return null;
    let {
      name,
      hasOppositeDirection,
      lineNumber,
      agencyId = "",
      route,
      // stops,
      // routeId,
      // directionId,
      // date,
      // time,
    } = dienstregeling;

    //Todo 26-11-2018: Deze data is nog niet beschikbaar uit de Moop api
    //const disabledAccessible = stops.filter(stop => stop.disabledAccessible).length === stops.length

    const lineText = config.lineText || "Line";
    const toText = config.toText || "to";

    const showMapBtn = !!dienstregeling.shape_ids.length;
    const showMapText = config.showMapText || "";
    const hideMapText = config.hideMapText || "";
    const showMap = this.state.showMap;
    const googleMapsSrc = showMap ? this.getGoogleMapsSrc() : "";

    return (
      <React.Fragment>
        <div
          className={`container container--center container--margin dienstregeling__detail ${
            loading ? "dienstregeling__detail--loading" : ""
          }`}
        >
          <div className="dienstregeling__info">
            <div
              className="dienstregeling__type"
              style={{
                background:
                  route.route_color !== null ? "#" + route.route_color : "",
                fill:
                  route.route_text_color !== null
                    ? "#" + route.route_text_color
                    : "",
              }}
            >
              <Icon className="dienstregeling__icon" iconName="bus" />
            </div>
            <div className="dienstregeling__line-and-route">
              <span className="sr-only" tabIndex="0">
                {lineText} {lineNumber} {toText} {name}
              </span>
              <div className="dienstregeling__line">
                {lineText} {lineNumber}
                {agencyId ? (
                  <span className="dienstregeling__consessie-naam">
                    {agencyId}
                  </span>
                ) : null}
              </div>
              <div className="dienstregeling__route">
                {name}
                {!hasOppositeDirection ? null : (
                  <div className="dienstregeling__switch-direction-container">
                    <button
                      className="dienstregeling__switch-direction js-switch-animation"
                      onClick={this.handleSwitchDirection}
                    >
                      <Icon
                        className="dienstregeling__switch-direction-icon"
                        iconName="arrow-reverse"
                        title={config.switchButtonLabel}
                      />
                    </button>
                    <p className="dienstregeling__switch-direction-container__text">
                      {config.changeDirectionText}
                    </p>
                  </div>
                )}
              </div>
            </div>
            {
              //Todo 26-11-2018: Deze data is nog niet beschikbaar uit de Moop api
              /* <div className="dienstregeling__accessibility">
            <span>Toegankelijkheid van deze bus: </span>
            <div className={!disabledAccessible ? 'dienstregeling__not-icon' : null}>
              <Icon iconName="wheelchair" />
            </div>
          </div> */
            }
          </div>
          <div className="dienstregeling__extra">
            <Prices
              dienstregeling={dienstregeling}
              prices={config.prices}
              compact={true}
            />
            {!showMapBtn ? null : (
              <button
                className="dienstregeling__map-toggle"
                onClick={this.handleToggleMap}
              >
                {showMap ? hideMapText : showMapText}
                <Icon
                  iconName={showMap ? "chevron-up" : "chevron-down"}
                  className="dienstregeling__map-toggle-indicator"
                />
              </button>
            )}
          </div>
        </div>
        {!showMap || !googleMapsSrc ? null : (
          <div className="dienstregeling__map">
            <img
              className="dienstregeling__map-image"
              alt="Route op de kaart"
              src={googleMapsSrc}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return state.dienstregeling;
  },
  { ...actions }
)(Detail);



// WEBPACK FOOTER //
// ./src/components/Dienstregeling/Detail.js